import { useDocumentationDirectoryUrlSynchronization } from 'store/documentation/hooks';
import { useDocumentationStore } from 'store/documentation';

export function useIsLoadingDocumentation(): boolean {
  const isLoadingAllDirectories = useDocumentationStore.use.isLoadingAllDirectories();
  const filteredRows = useDocumentationStore.use.filteredRows();
  return isLoadingAllDirectories && filteredRows.length === 0;
}

/**
 * Hook to synchronize documentation URL with Zustand store.
 * Delegates to the Zustand-based implementation.
 */
export function useDocumentationUrlControl(): void {
  useDocumentationDirectoryUrlSynchronization();
}
